export default __webpack_public_path__ + "static/media/IMG_3446 copie.64581aa2.jpg";